import { render } from "./DrugEdit.vue?vue&type=template&id=1a787d3e&scoped=true"
import script from "./DrugEdit.vue?vue&type=script&lang=js"
export * from "./DrugEdit.vue?vue&type=script&lang=js"

import "./DrugEdit.vue?vue&type=style&index=0&id=1a787d3e&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a787d3e"]])

export default __exports__